<nz-spin [nzSpinning]="loading$ | async">
  <form nz-form class="form" nzLayout="horizontal" [formGroup]="form">
    <div class="drawer-form-wrapper">
      <h3 class="title s-16 mb-16">
        {{ drawerParmas.selectedDay }},
        {{ drawerParmas.selectedDate | date: 'MMMM dd, yyyy' }}
      </h3>
      <div formArrayName="dataItems">
        <nz-table
          class="number-of-minutes mb-24"
          #basicTable
          [nzData]="dataItems.controls"
          nzShowPagination="false"
          [nzScroll]="{ x: '700px', y: 'calc(100vh - 290px)' }">
          <thead>
            <tr>
              <td
                *ngFor="let control of dataItemsControls; let i = index"
                [formGroup]="control"
                [title]="
                  getTitle(
                    control.value.startDataTime,
                    control.value.endDataTime
                  )
                ">
                {{
                  getTitle(
                    control.value.startDataTime,
                    control.value.endDataTime
                  )
                }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                *ngFor="let control of dataItemsControls; let i = index"
                [formGroup]="control">
                <input
                  name="enterMinutes"
                  type="text"
                  nz-input
                  [mask]="'000'"
                  [validation]="false"
                  appAllowOnlyValidNumbers
                  placeholder="Number of Occurences"
                  formControlName="unitValue" />
              </td>
            </tr></tbody
        ></nz-table>
        <div class="error-text mt-3 mb-3" *ngIf="!isFormValid">
          Please enter at least 1 Frequency value.
        </div>
      </div>
      <p class="error-text mb-24">
        Enter numeric value for either Frequency Interval.
      </p>
      <div class="display-flex justify-content-between drawer-footer">
        <button nz-button type="button" nzType="default" (click)="onCancel()">
          Cancel
        </button>
        <div class="display-flex button-group-gap">
          <ng-container *ngIf="drawerParmas.selectedUnit !== 1">
            <button
              nz-button
              type="button"
              nzType="primary"
              (click)="submitForm()"
              [disabled]="!isFormValid">
              Save & Close
            </button>
            <button
              *ngIf="hasNextDate"
              nz-button
              type="button"
              nzType="primary"
              (click)="submitAndNext()"
              [disabled]="!isFormValid">
              Save & Next
            </button>
          </ng-container>

          <ng-container *ngIf="drawerParmas.selectedUnit === 1">
            <button
              nz-button
              type="button"
              nzType="primary"
              (click)="submitForm()"
              [disabled]="!isFormValid">
              Save & Close
            </button>
            <button
              *ngIf="
                hasNextDateForUnit1 &&
                (nextDateHasFrequency || nextDateHasNoData)
              "
              nz-button
              type="button"
              nzType="primary"
              (click)="submitAndNext()"
              [disabled]="!isFormValid">
              Continue With Frequency
            </button>
            <button
              *ngIf="
                hasNextDateForUnit1 &&
                (nextDateHasDuration || nextDateHasNoData)
              "
              nz-button
              type="button"
              nzType="primary"
              (click)="continueWithDuration()"
              [disabled]="!isFormValid">
              Continue With Duration
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </form></nz-spin
>
